module.exports = __webpack_public_path__ + "static/media/Swashbuckler.1990ad75.jpg";